import React from "react";
import styles from "./PricingHero.module.css";

const PricingHero = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.overlay}>
         <h1 className={styles.title}>
          Sparklio - The Future  of  <br />
          <span className={styles.highlightText}>Apartment Management</span>
        </h1>

        <p className={styles.subtitle}>
         From manual maintenance tracking to automated resident ledgers, 
          choose a plan that scales with your community's needs. No hidden costs—just 
          absolute financial transparency for your committee.
        </p>

        <p className={styles.tagline}>
          Secure • Transparent • Hassle-Free Society Management
        </p>
      </div>
    </section>
  );
};

export default PricingHero;
